// extracted by mini-css-extract-plugin
module.exports =  {"paragraph":"KhdRBzmVbKrPlWUGYcC1"};